var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12258_117029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4698 11.0391C11.7674 11.5273 10.9103 11.8131 9.99958 11.8131C9.08887 11.8131 8.23172 11.5273 7.52934 11.045C6.38053 11.5452 5.46387 12.4919 5.02934 13.7125C4.90434 14.0638 4.7972 14.4151 4.71387 14.7783C6.02339 16.2192 7.9103 17.1302 9.99958 17.1302C12.0889 17.1302 13.9817 16.2192 15.2912 14.7783C15.2079 14.421 15.1008 14.0697 14.9758 13.7125C14.5412 12.4859 13.6127 11.5452 12.4758 11.0391H12.4698Z",
    fill: "#A7A39A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99977 10.3527C11.6069 10.3527 12.9224 9.04878 12.9224 7.42925C12.9224 5.80972 11.6069 4.51172 9.99977 4.51172C8.39262 4.51172 7.07715 5.81568 7.07715 7.42925C7.07715 9.04283 8.39262 10.3527 9.99977 10.3527Z",
    fill: "#A7A39A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4881 0 0 4.48348 0 9.99702C0 15.5106 4.4881 20 10 20C15.5119 20 20 15.5106 20 9.99702C20 4.48348 15.5119 0 10 0ZM10 18.5591C5.27976 18.5591 1.43452 14.7187 1.43452 9.99107C1.43452 5.26347 5.27976 1.43495 10 1.43495C14.7202 1.43495 18.5655 5.27538 18.5655 9.99702C18.5655 14.7187 14.7262 18.565 10 18.565V18.5591Z",
    fill: "#A7A39A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12258_117029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeHeader);
export default __webpack_public_path__ + "static/media/iconeHeader.2221ce2645ba08dc7ac73f89a709242b.svg";
export { ForwardRef as ReactComponent };